var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5013 3.00098L34.8346 9.00098M3.16797 33.001L5.18894 25.9808C5.32079 25.5228 5.38671 25.2938 5.48792 25.0802C5.57778 24.8906 5.68819 24.7103 5.81739 24.5424C5.96289 24.3532 6.14006 24.1853 6.4944 23.8496L22.8556 8.3495C23.1691 8.05249 23.3259 7.90399 23.5067 7.84834C23.6657 7.7994 23.8369 7.7994 23.9959 7.84834C24.1767 7.90399 24.3335 8.05249 24.647 8.3495L29.189 12.6524C29.5025 12.9495 29.6592 13.098 29.718 13.2692C29.7696 13.4198 29.7696 13.5821 29.718 13.7327C29.6592 13.904 29.5025 14.0525 29.189 14.3495L12.8277 29.8496C12.4734 30.1853 12.2962 30.3532 12.0965 30.491C11.9192 30.6134 11.7289 30.718 11.5288 30.8031C11.3034 30.899 11.0616 30.9615 10.5782 31.0864L3.16797 33.001Z",
    stroke: "#D1E0FF",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconOutline);
export default __webpack_public_path__ + "static/media/edit-icon-outline.c416b551a86295e0c9c2c5220a153a35.svg";
export { ForwardRef as ReactComponent };